/* eslint-disable */
const modulesFiles = require.context("@/utils/hardware", true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1")
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

import Vue from "vue"

export class SigManage {
  constructor(global) {
    this._name = "sig-manage"

    // 导入全局变量
    this._global = global

    // 主进程数据监听初始化
    this._init()

    this.longPressTimer = null

    // 功率列表
    this.powerList = []

    // 应急配电板的灯集合
    this.emergencyList = [
      "Sys_J03_V",
      "Sys_J04_V",
      "Sys_J05_V",
      "Sys_J04_J05_V",
    ]

    // 主配电板的灯集合
    this.mainList = [
      "Sys_K01_K02_V",
      "Sys_K03_K04_V",
      "Sys_K05_V",
      "Sys_K06_V",
      "Sys_K07_V",
      "Sys_L01_V",
      "Sys_L02_L03_V",
      "Sys_L04_L05_V",
      "Sys_L06_V",
    ]
  }

  _init() {
    let _this = this
    let ipcRenderer = window.$ipcRenderer
    if (!ipcRenderer) {
      return
    }

    // 日志记录
    ipcRenderer.on("recv-log", (event, data) => {
      console.log("recv-log:", data.msg, data.data)
    })

    // 串口数据接收
    ipcRenderer.on("recv-com", (event, data) => {
      // console.log("recv-com:", data)

      let address = data.address

      let type = data.type
      let id = data.id
      let value = data.value

      let json = null
      for (let i in modules) {
        let module = modules[i]
        if (address !== Number(i)) {
          continue
        }
        json = module.hardwareToSoft(id, value, type)
      }

      if (json) {
        if (address === 1265 || address === 1266) {
          // 硬件地址:车钟操作
          this.setClockStateCom(json.value, address)
          return
        }

        // 本地车钟
        if (address === 1267) {
          this.setClockStateComLocal(json.value)
          return
        }

        if (id >= 7) {
          // 其他id通用
          this.clearFrequencyTimer()
          let data = {
            nodeId: json.nodeId,
            targetId: json.targetId,
            mode: json.mode,
          }
          window.$http
            .post(json.currentCommand, data)
            .then((response) => {})
            .catch((error) => {
              console.log("error: ", error)
            })
        }

        let generatorId = ""
        if (id === 1 || id === 2) {
          generatorId = "mainGenerator1"
        } else if (id === 3 || id === 4) {
          generatorId = "mainGenerator2"
        } else if (id === 5 || id === 6) {
          generatorId = "mainGenerator3"
        }

        // 调频:id小于7,且当前发电机未合闸,调速开关调节频率
        if (
          id < 7 &&
          !_this._global.generatorClosedNumber.includes(generatorId)
        ) {
          if (value === 1) {
            this.sendFrequency(json)
          } else {
            this.clearFrequencyTimer()
          }
        }

        // 调功率,当前发电机已合闸的情况下,调速开关调节功率
        if (
          id < 7 &&
          _this._global.generatorClosedNumber.includes(generatorId)
        ) {
          let state = json.state
          this.changeSpeedSwitchState(id, state)
        }
      }
    })
  }

  // 每秒发送频率
  sendFrequency(json) {
    let mode = json.mode
    let nodeId = json.nodeId
    let targetId = json.targetId
    let currentCommand = json.currentCommand

    let data = {
      mode,
      nodeId,
      targetId,
    }
    window.$http
      .post(currentCommand, data)
      .then(() => {})
      .catch((error) => {
        console.log("error: ", error)
      })
    // 设置重复执行的定时器，每1000ms执行一次
    this.longPressTimer = setInterval(() => {
      window.$http
        .post(currentCommand, data)
        .then(() => {})
        .catch((error) => {
          console.log("error: ", error)
        })
    }, 1000)
  }

  // 清除频率定时器
  clearFrequencyTimer() {
    if (this.longPressTimer) {
      clearInterval(this.longPressTimer)
      this.longPressTimer = null
    }
  }

  // 改变speedSwitchState状态
  changeSpeedSwitchState(id, state) {
    for (let i in this._global.speedSwitchState1) {
      let item = this._global.speedSwitchState1[i]
      if (item.id === id) {
        item.state = state
        // 响应式赋值
        Vue.set(this._global.speedSwitchState1, i, item)
        break
      }
    }
    for (let i in this._global.speedSwitchState2) {
      let item = this._global.speedSwitchState2[i]

      if (item.id === id) {
        item.state = state
        // 响应式赋值
        Vue.set(this._global.speedSwitchState2, i, item)
        break
      }
    }
    for (let i in this._global.speedSwitchState3) {
      let item = this._global.speedSwitchState3[i]
      if (item.id === id) {
        item.state = state
        // 响应式赋值
        Vue.set(this._global.speedSwitchState3, i, item)
        break
      }
    }
  }

  // 每一个字节后面追加一个空格
  formatNumber(num, chart = " ", length = 2) {
    let result = ""
    let nums = num.toString().split(".")
    let int = nums[0]
    let decmial = nums[1] ? "." + nums[1] : ""
    let index = 0
    for (let n = int.length - 1; n >= 0; n--) {
      index++
      result = int[n] + result
      if (index % length === 0 && n !== 0) {
        result = chart + result
      }
    }
    return result + decmial
  }

  strToHexCharCode(d) {
    d = d.toString().padStart(4, "0")
    d = ("0" + Number(d).toString(16)).slice(-4).padStart(4, "0")
    return d
  }

  // 设置警报,灯的亮灭
  setAlarmState(data) {
    let client = window.$client
    if (!client) {
      return
    }

    data.type = this.formatNumber(data.type.toString().padStart(2, "0"))
    data.value = this.formatNumber(this.strToHexCharCode(data.value))
    data.id = this.formatNumber(this.strToHexCharCode(data.id))
    // 重新计算长度
    data.size = this.formatNumber(
      this.strToHexCharCode((9 + 5 * 1).toString()).padStart(4, "0"),
    )
    data.address = this.formatNumber(this.strToHexCharCode(data.address))
    data.cellLen = "00 01"
    // 软件发送02
    data.sign = "02"
    data.header = "48 47"
    let str =
      data.header +
      " " +
      data.sign +
      " " +
      data.cellLen +
      " " +
      data.size +
      " " +
      data.address +
      " " +
      data.type +
      " " +
      data.id +
      " " +
      data.value +
      " "
    let strs = str.split(" ")
    let newArr = strs.filter((item) => {
      return item !== ""
    })
    for (let i = 0; i < newArr.length; i++) {
      newArr[i] = "0x" + strs[i]
    }

    let buff = Buffer.from(newArr)

    client.write(buff, (err) => {
      if (err) {
        // console.log("tcp发送错误", err)
      } else {
        console.log("tcp发送成功", data)
      }
    })

    client.on("data", (data) => {
      // console.log("Received:", data.toString())
    })

    client.on("error", (err) => {
      // console.log("Error:", err)
    })
  }

  // 转换成十六进制数据
  ToHexCharCode(data) {

    data.type = this.formatNumber(data.type.toString().padStart(2, "0"))
    data.value = this.formatNumber(this.strToHexCharCode(data.value))
    data.id = this.formatNumber(this.strToHexCharCode(data.id))
    // 重新计算长度
    data.size = this.formatNumber(
      this.strToHexCharCode((9 + 5 * 1).toString()).padStart(4, "0"),
    )
    data.address = this.formatNumber(this.strToHexCharCode(data.address))
    data.cellLen = "00 01"
    // 软件发送02
    data.sign = "02"
    data.header = "48 47"
    let str =
      data.header +
      " " +
      data.sign +
      " " +
      data.cellLen +
      " " +
      data.size +
      " " +
      data.address +
      " " +
      data.type +
      " " +
      data.id +
      " " +
      data.value +
      " "
    let strs = str.split(" ")
    let newArr = strs.filter((item) => {
      return item !== ""
    })
    for (let i = 0; i < newArr.length; i++) {
      newArr[i] = "0x" + strs[i]
    }

    return newArr
  }

  sendHexMessages(hexMessages) {
    let client = window.$client
    if (!client) {
      return
    }

    const messageBuffer = Buffer.from(hexMessages)

    client.write(messageBuffer, (err) => {
      if (err) {
        // console.log("tcp发送错误", err)
      } else {
        // console.log("tcp发送成功")
      }
    })
  }

  // tcp消息
  setLed(state) {
    let value = 0
    if (state) {
      value = 1
    }

    let json = {
      type: 2,
      address: 1234,
      id: 16,
      value: value,
    }

    let str = this.ToHexCharCode(json)

    this.sendHexMessages(str)
  }

  // 发送串口消息,设置电站灯亮灭
  setLedStateCom(state, type) {
    let addr = window.$ledAddr
    let id = window.$ledId

    if (!addr || !id) {
      console.log("灯的串口地址或id为空")
      return
    }

    // 判断对应的灯亮起
    let flag = false

    if (type === "emergency") {
      if (this.emergencyList.includes(window.$sysName)) {
        flag = true
      }
    } else {
      if (this.mainList.includes(window.$sysName)) {
        flag = true
      }
    }

    if (!flag) {
      return
    }

    let ipcRenderer = window.$ipcRenderer

    if (!ipcRenderer) {
      return
    }

    let value = 0
    if (state) {
      value = 1
    }

    let json = {}
    // 类型为led灯
    json.type = 2
    json.address = addr
    json.id = id
    json.value = value

    let hexArr = this.ToHexCharCode(json)

    let messageBuffer = Buffer.from(hexArr)

    try {
      ipcRenderer.send("send-com", messageBuffer)
      console.log("串口消息发送成功（Hex模式）:", messageBuffer, addr)
    } catch (error) {
      console.error("发送串口消息失败:", error)
    }
  }

  // 发送车钟消息给服务器,http消息
  setClockStateCom(value, address) {
    let system = ""
    let nodeId = ""

    if (address === 1266) {
      // 集控台
      system = "ECR"
      nodeId = "tab_M07_1"
    } else if (address === 1265) {
      // 驾驶台
      system = "BRIDGE"
      nodeId = "tab_N01_1"
    }

    if (!system || !nodeId) {
      console.log("车钟的系统名或节点id为空")
      return
    }

    // 判断当前权限是否能推车钟,只有对应自己权限才能发车钟消息
    if (
      (window.$global.hostData.system === "BRIDGE" &&
        window.$global.hostData.rule === "BRIDGE") ||
      (window.$global.hostData.system === "ECR" &&
        window.$global.hostData.rule === "ECR")
    ) {
      if (system === "ECR") {
        // 转成小写
        if (
          window.$global.hostData.ECRMachineTelegraph.toLowerCase() ===
          value.toLowerCase()
        ) {
          return
        }
      } else if (system === "BRIDGE") {
        // 转成小写
        if (
          window.$global.hostData.BGMachineTelegraph.toLowerCase() ===
          value.toLowerCase()
        ) {
          return
        }
      }

      // 构造完整的消息对象
      const data = {
        nodeId,
        targetId: "mainFrame",
        state: true,
        system,
        param: value,
      }

      window.$http
        .post("/HostLocalControl/knob/gear", data)
        .then((res) => {
          let code = res.code
          if (code !== 200) {
            return
          }

          if (code === 200) {
            if (system === "ECR") {
              window.$global.currentAlarmSys = "Sys_N01"
            } else if (system === "BRIDGE") {
              window.$global.currentAlarmSys = "Sys_M07"
            }

            window.$global.alarmLedBlink[
              window.$global.currentAlarmSys
            ].state = true

            window.$global.currenthighlightGear = value
          }
        })
        .catch((error) => {
          console.error("发送数据到后端失败:", error)
        })
    }
  }

  // 发送本地车钟消息给服务器,http消息
  setClockStateComLocal(value) {
    if (
      window.$global.hostData.system === "LOCAL" &&
      window.$global.hostData.rule === "LOCAL"
    ) {
      // 判断当前推的车钟值和当前车钟值是否一致,一致的话不发送
      if (Number(window.$global.hostData.mainGear) === Number(value)) {
        return
      }

      // 构造完整的消息对象
      const data = {
        nodeId: "knob_A03_2",
        targetId: "mainFrame",
        mode: value.toString(),
      }

      window.$http
        .post("/HostLocalControl/knob/mainGear", data)
        .then((res) => {
          let code = res.code
          if (code !== 200) {
            return
          }

          // 越位,发出蜂鸣声
          if (value === "-3" || value === "3") {
            if (
              window.$global.systemId === "Sys_M07" ||
              window.$global.systemId === "Sys_N01" ||
              window.$global.systemId === "Sys_A03"
            ) {
              window.$global.standbyAudio.play()
            }
          } else {
            if (
              window.$global.systemId === "Sys_M07" ||
              window.$global.systemId === "Sys_N01" ||
              window.$global.systemId === "Sys_A03"
            ) {
              window.$global.standbyAudio.pause()
            }
          }
        })
        .catch((error) => {
          console.error("发送数据到后端失败:", error)
        })
    }
  }
}
